<template>
  <v-layout align-content-start row wrap justify-start v-if="training">
    <v-flex xs12 md4>
      <section class="section-box">
        <h3 class="subsection-title">
          Exercícios
        </h3>

        <v-flex xs12>
          <v-text-field v-model="search" class="search-input" placeholder="Procurar Exercícios...."
            append-icon="fal fa-search" hide-details></v-text-field>
        </v-flex>

        <!-- <v-flex xs12>
          <v-select v-model="searchMuscle" label="Grupo muscular"
            :items="['Sim', 'Não']" append-icon="fal fa-angle-down"></v-select>
        </v-flex> -->

        <v-flex xs12>
          <h3 class="section-title small">
            Lista Completa
          </h3>
        </v-flex>

        <div class="text-xs-center mx-4 my-2" style="color: #777" v-show="!exercises.length">
          Nenhum exercício cadastrado
        </div>

        <admin-new-edit-exercise></admin-new-edit-exercise>

        <div class="exercise-list">
          <v-layout class="exercise-item" row wrap align-center justify-center
            v-for="(exercise, index) in filteredExercises" :key="index">
            <v-flex xs10>
              {{ exercise.name }}
            </v-flex>
            <v-flex xs2>
              <v-btn flat small color="teal" @click="addExercise(exercise)">
                <v-icon>fal fa-plus-square</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>

        <div class="text-xs-center my-2">
          <v-btn round depressed dark
            v-modal-trigger="'showNewEditExercise'">
            NOVO EXERCÍCIO
            <v-icon small right>fal fa-plus-circle</v-icon>
          </v-btn>
        </div>
      </section>
    </v-flex>
    <v-flex xs12 md8>
      <section class="section-box">
        <h3 class="subsection-title">
          Novo treino
        </h3>

        <v-layout row wrap align-center justify-center>
          <v-flex xs12 md4>
            <v-text-field v-model="training.name" label="Nome do treino" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field v-model="training.level" label="Nível" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field v-model="training.sessions" label="Sessões" type="number" hide-details></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-text-field v-model="training.description" label="Descrição"></v-text-field>
          </v-flex>

          <v-flex xs12>
            <div width="100%">
              <div class="v-table__overflow">
                <table class="v-datatable v-table" width="100%">
                  <thead>
                    <tr>
                      <th scope="col" class="column text-xs-left">Exercícios</th>
                      <th scope="col" width="80" class="column">Séries</th>
                      <th scope="col" width="80" class="column">Repetições</th>
                      <th scope="col" width="80" class="column">Carga</th>
                      <th scope="col" width="80" class="column">Intervalo</th>
                      <th scope="col" width="80" class="column">Intensidade</th>
                      <th scope="col" width="80" class="column"></th>
                    </tr>
                  </thead>
                  <draggable element="tbody" v-model="training.exercises" @start="drag=true" @end="drag=false">
                    <tr v-for="(item, index) in training.exercises" :key="index">
                      <td style="cursor: move;">{{ item.name }}</td>
                      <td>
                        <v-text-field hide-details v-model="item.series" solo></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.repetitions" hide-details solo></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.weight" hide-details solo></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.interval" hide-details solo></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.amplitude" hide-details solo></v-text-field>
                      </td>
                      <td class="align-center text-xs-right">
                        <v-btn flat small color="error" @click="removeExercise(item)">
                          <v-icon>fal fa-times-square</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </draggable>
                </table>
              </div>
            </div>
            <div class="my-3 text-xs-center" v-show="!training.exercises.length">
              Adicione um exerício
            </div>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.stop="save()" round large depressed color="success"
            :loading="loadingRequest">
            Salvar <span v-if="training.save_into_model">modelo</span>
          </v-btn>
        </v-card-actions>
      </section>
    </v-flex>
  </v-layout>
</template>

<script>
import router from '@/router'
import draggable from 'vuedraggable'
import axios from 'axios'
import EventBus from '@/event-bus'
import AdminNewEditExercise from '@/components/admin/exercises/AdminNewEditExercise'

export default {
  data: () => ({
    search: '',
    searchMuscle: '',
    loadingRequest: false,
    training: {
      exercises: [],
      save_into_model: false
    },
    exercises: []
  }),

  methods: {
    addExercise (exercise) {
      const newExercise = {
        _id: exercise._id,
        name: exercise.name,
        video_link: exercise.video_link,
        series: 0,
        repetitions: 0,
        weight: 0,
        interval: 0,
        amplitude: 0
      }

      if (!this.training.exercises) { this.training.exercises = [] }

      this.training.exercises.push(newExercise)

      this.$nextTick(() => {
        EventBus.$emit('updateTraining', this.training)
      })
    },

    removeExercise (item) {
      const index = this.training.exercises.indexOf(item)
      this.training.exercises.splice(index, 1)
    },

    save () {
      this.loadingRequest = true
      let $request = null

      if (this.training._id) {
        // eslint-disable-next-line
        $request = axios.put(`${API.userTrainings}/${this.training._id}`, this.training)
      } else {
        // eslint-disable-next-line
        $request = axios.post(API.userTrainings, this.training)
      }

      if (this.user) { this.training.user = this.user }

      // eslint-disable-next-line
      $request.then(response => {
        EventBus.$emit('showSnackbar', { message: 'Treino salvo com sucesso!', color: 'success' })
        EventBus.$emit('appLoading', false)
        this.redirect()
        this.loadingRequest = false
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro ao salvar o treino', color: 'error' })
        EventBus.$emit('appLoading', false)
        this.loadingRequest = false
      })
    },

    loadExercises () {
      // eslint-disable-next-line
      axios.get(API.userExercises).then(response => {
        this.exercises = response.data.exercises
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar os exercícios', color: 'error' })
        EventBus.$emit('appLoading', false)
      })
    },

    redirect () {
      if (this.user) {
        EventBus.$emit('showNewTrainingDialog', false)
        EventBus.$emit('userLoadTrainings', false)
        EventBus.$emit('loadTrainings', false)
      } else {
        router.push({ name: 'AdminTrainings' })
      }
    }
  },

  computed: {
    filteredExercises () {
      return this.exercises.filter(exercise => {
        return exercise.name.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },

  components: {
    draggable,
    'admin-new-edit-exercise': AdminNewEditExercise
  },

  beforeDestroy () {
    EventBus.$off('loadTraining')
    EventBus.$off('loadExercises')
  },

  mounted () {
    if (this.currentTraining) {
      this.training = this.currentTraining
    }

    if (this.saveIntoModel) {
      this.training.save_into_model = true
    }

    this.loadExercises()

    EventBus.$on('loadTraining', training => {
      this.training = training
    })

    EventBus.$on('loadExercises', this.loadExercises)
  },

  props: ['saveIntoModel', 'currentTraining', 'user']
}
</script>

<style scoped>
  .v-btn {
    min-width: auto;
  }

  .exercise-item {
    padding: 10px 15px;
  }

  .exercise-item:hover {
    background: #f0f0f0;
  }

  .exercise-list {
    max-height: 400px;
    overflow: hidden;
    overflow-y: auto;
  }

  table .v-input {
    max-width: 60px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/trainings/NewTrainingComponent.vue